import React from 'react';
import { Reports as ReportsComponent } from '~/components/Admin';

export function Reports() {
    return <ReportsComponent />;
}
